import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ashok from "../../Images/2001.jpg";
import ashok1 from "../../Images/2010.jpg";
import two15 from "../../Images/2015.jpg";
import two15p2 from "../../Images/2015P2.png";
import japl from "../../Images/japl-logo.png";
import two18 from "../../Images/2018.jpg";
import ninty73 from "../../Images/Founder.jpeg";
import ninty82 from "../../Images/milestone-1982.jpeg";
import ninty83 from "../../Images/milestone-1983.jpeg";
import ninty92 from "../../Images/1992.jpg";
import ninty97 from "../../Images/milestone-1996.jpeg";
import two3 from "../../Images/2003.jpg";
import two7 from "../../Images/2007.jpg";
import two9 from "../../Images/2009.jpg";
import two8 from "../../Images/2008.jpeg";
import two11 from "../../Images/2011.jpg";
import two11p2 from "../../Images/2011-P2.png";
import two12 from "../../Images/2012.jpg";
import two16 from "../../Images/2016.jpg";
import two16p2 from "../../Images/2016p2.png";
import two16p3 from "../../Images/2016p3.png";
import two17p1 from "../../Images/2017p1.png";
import two17 from "../../Images/2017.jpg";
import two19 from "../../Images/2019.jpg";
import two20 from "../../Images/2020.jpg";
import two20p2 from "../../Images/2020p2.png";
import Turbo from '../../Images/Turbo.jpg'
import ninty96 from '../../Images/1996-P1.png'
import two23 from "../../Images/turbo-award.jpg";
import two23p2 from "../../Images/tata-award.jpg";
import two23p3 from "../../Images/2023p3.png";
import two23p4 from "../../Images/2023p4.png";
import two24p1 from "../../Images/2024p1.png";
import two24p2 from "../../Images/2024.png";
import two24p3 from "../../Images/2024p3(1).png";

const timelineData = [
  {
    year: "1973",
    title: "Janatha Auto Works Founded",
    description:
      "Janatha Auto Works was founded by Late Gooty Dada Sab along with two friends  in Gangavathi in 1973.",
    image: ninty73
  },
  {
    year: "1982",
    title: "",
    location: "",
    description:
      "Friends parted ways, with one friend establishing own workshop at Hospet and the other friend starting his workshop in Chitradurga.",
    // "Expansion of business as one of the founders opened a workshop in Hospet and another in Chitradurga.",
    image: ninty82
  },
  {
    year: "1983",
    title: "JANATHA AUTO WORKS FIRST EXPANSION OUTSIDE GANGAVATHI",
    // location: "Kushtagi",
    description:
      // "Janatha Auto Works established, 2S spare and service shop in Kushtagi, marking the first expansion of Janatha Auto Works outside Gangavathi.",
      "Janatha Auto Works established a 2S (Spares & Service) workshop in Kushtagi in 1983. This was the first venture outside Gangavathi since inception.",
    image: ninty83
  },
  {
    year: "1992",
    title: "JANATHA AUTO WORKS NEW WORKSHOP IN GANGAVATHI",
    description:
      // "After 10 years of dedicated service, Managed to build A new six-bay workshop on our own land.",
      "	After 10 years of dedication and hard work, Janatha Auto Works managed to build a new facility consisting of 6 bays on its own 1 acre land purchased in Gangavathi in 1992. This new facility proved instrumental in managing increased workflow back then.",
    image: ninty92
  },
  {
    year: "1996",
    title: "Janatha Auto Works establishes a New water service facility",
    description:
      "With the intention to provide value added service to customer, we started our own Water service facility in the workshop in 1996. ",
    image: ninty96
  },
  {
    year: "1997",
    title: "Janatha Auto Works adds machining services enhancing operational efficiency",
    description:
      "In 1997, under the leadership of G. Aslam Bhai and his mentor Noor Khan Sab, a machine shop was also established. The work that previously had to be outsourced was now being done in-house. This not only saved time but also led to an improvement in work quality and increased customer satisfaction.",
    image: ninty97
  },
  {
    year: "2002",
    title: "Janatha Auto Works becomes TVS Sundaram Motors Authorised Service Station in Gangavathi (SMASS)",
    description:
      "Janatha auto works, becomes TVS Sundaram Motors Authorized Service Station (SMASS) for Ashok Leyland vehicles in Gangavathi on 16th Sep 2002.",
    image: ashok
  },
  {
    year: "2003",
    title: "JANATHA AUTO WORKS - SMASS, Beginning of a New Workshop in Hospet",
    description:
      "Increased mining activity around 2003 necessitated an establishment of new facility at Hospet. A new workshop officially started operations on 27th Nov 2003.",
    image: two3
  },
  // {
  //   year: "2004",
  //   title: "Machine Shop at Hospet Workshop",
  //   description:
  //     "Machine shop established at the Hospet workshop to improve service delivery and efficiency.",
  //   image:
  //     "https://res.cloudinary.com/dk10z0h1f/image/upload/v1742362110/bg-3_bw3pj2.jpg"
  // },
  {
    year: "2007",
    title: "Janatha Auto Works RANE-TRW ASC AT HOSPET",
    description:
      "After nearly two years of continuous follow-up, by the grace of Allah, in 2007 we were appointed as an Authorized Service Center for RANE TRW Power Steering Systems. This facility was established within the premises of our Hospet workshop.",
    image: two7
  },
  {
    year: "2008",
    title: "Janatha Auto Works, starts Engine Reconditioning Workshop at Hospet",
    description:
      "Due to the lack of in-house engine refurbishing services, many tasks had to be outsourced — often handled by vendors from Bangalore or other cities. To overcome this problem, Janatha auto works started a dedicated Engine Reconditioning Workshop in Hospet. The facility began operations on 1st February 2008 at Hampi Road, Hospet.",
    image: two8
  },
  {
    year: "2009",
    title: "Janatha Auto Works Ventures into Battery Business",
    description:
      "In 2009, Janatha Auto Works was appointed as an Exide Battery Distributor for the entire Koppal district for sales and service.",
    image: two9
  },
  {
    year: "2010",
    title: "Janatha Auto Works, Gangavathi appointed as Ashok Leyland ASC",
    description:
      "In 2010, Ashok Leyland introduced new rules prohibiting dealers from appointing sub-dealers under them. As a result, Janatha Auto Works, which was previously an authorized service center under Sundaram Motors, was directly appointed by Ashok Leyland as the Authorized Service Center for the entire Koppal district. This appointment took place on February 24, 2010.",
    image: ashok1
  },
  {
    year: "2011 P1",
    title: "Janatha Auto Works awarded an at site AMC for maintaining Ashok Leyland Vehicles of SWML",
    description:
      "Ashok Leyland had sold 80 vehicles to SWML under an 'At Site AMC' deal. To service these vehicles, Ashok Leyland appointed Janatha Auto Works as the authorized service provider. This AMC contract was for five years and it proved to be a major milestone in Janatha Auto Works' journey.",
    image: two11
  },
  {
    year: "2011 P2",
    title: "Janatha Auto Works Awarded an AMC contract from NMDC for maintenance of its Staff Buses",
    description:
      "The AMC contract Janatha Auto Works received from SWML in 2011 served as a strong reference, through which we also secured an AMC contract from NMDC. This contract was awarded on March 15, 2011, for the maintenance of NMDC’s 8 Ashok Leyland staff buses.",
    image: two11p2
  },
  {
    year: "2012 P1",
    title: "Janatha Auto Works Kurekuppa branch becomes Ashok Leyland ASC",
    description:
      "This branch was started initially as a container workshop in March 2011. This was later converted into a 7-bay facility in 2012, acting as Ashok Leyland autorized service center. After becoming TATA Motors dealer in 2018, it was further upgraded into a full-fledged 15-bay workshop.",
    image: two12
  },
  {
    year: "2012 p2",
    title: "Janatha Auto Works, Hospet is Tel Turbo Authorised Service Center",
    description:
      "Janatha Auto Works, appointed as Authorized Service Center (ASC) by Tel Turbo Energy Limited for Bellary district, This Authorized Service Center began operations on 12th March 2012. This TEL ASC has been successfully running ever since.",
    image: Turbo
  },
  {
    year: "2015 P1",
    title: "Janatha Auto Works, Chitradurga becomes Authorised Service Center for three OEM Brands in the same year.",
    description:
      "In 2015, Janatha Auto Works began operations as an Authorized Service Center for three OEM brands: TEL Turbo Energy Ltd, RANE Power Steering Systems, and WABCO Control Systems The inauguration of all three ASCs in Chitradurga took place on 21st October, 2015",
    image: two15
  },
  {
    year: "2015 P2",
    title: "JANATHA AUTO WORKS CONTAINER WORKSHOPS, BELGAUM & BIJAPUR",
    description:
      "Based on Ashok Leyland’s recommendation, container workshops were established in Belgaum and Bijapur in 2015. These workshops continued providing services from 2015 until 2018, til we became associated with TATA Motors.",
    image: two15p2
  },
  {
    year: "2016 P1",
    title: "JANATHA AUTO WORKS, establishes second Engine Reconditioning Workshop, at Bellary",
    description:
      "In 2016, we established our second reconditioning workshop in Bellary. This decision was taken due to the increasing demand for engine reconditioning services. The workshop officially commenced operations on January 6, 2016.",
    image: two16
  },
  {
    year: "2016 p2",
    title: "JANATHA AUTO WORKS FORAYS INTO DEVELOPMENT WORKS AT NMDC MINES",
    description:
      "In 2016, Rocktech appointed us as their sub-contractor for this project. To execute this work order, we had deployed a fleet of 18 vehicles initially which has grown now to 50 vehicles, and this continues to operate to this day.",
    image: two16p2
  },
  {
    year: "2016 p3",
    title: "JANATHA CSR INITIATIVES – ESTABLISHES IQRA PUBLIC SCHOOL",
    description:
      "In 2016, IQRA Public School was launched through the IQRA Foundation Trust. School began functioning officially from June 1, 2016 running classes from Nursery till class 5th. Now, By the grace of Allah, After 9 years, School has got permission to run classes till 10th standard. Today, with nearly 500 students receiving education, supported by 30 teachers and 6 non-teaching staff, Iqra School has established its reputation in Gangavathi as one of the finest schools in town.",
    image: two16p3
  },
  {
    year: "2017 P1",
    title: "JANATHA AUTO WORKS - SLR WORK ORDER",
    description:
      "Janatha Auto Works got a 3 year work assignment from SLR Metalliks for shifting of Hot metal Slabs. This was a new learning experience which gave us confidence to accompolish new challenges confidently.",
    image: two17p1
  },
  {
    year: "2017 P2",
    title: "AWARDS",
    description:
      "Janatha Auto Works, Gangavathi branch ASC was awarded the Best Performance Award by Ashok Leyland for achieving the vehicle inflow revenue (GVT) target for the financial year 2016-17. Janatha Auto Works, Kurekuppa branch ASC was awarded the Best Performance Award by Ashok Leyland for achieving the highest revenue of ₹8 crore in the financial year 2016–17.",
    image: two17
  },
  {
    year: "2018",
    title: "TATA MOTORS 3S DEALERSHIP (SALES, SERVICE, SPARE PARTS) – JANATHA AUTOMOBILES PRIVATE LIMITED",
    description:
      "Janatha Automobiles Private Limited, a new company is established under Janatha banner marking the beginning of a new journey. It was a significant turning point that took us to a new level in the automobile industry, and gave us the opportunity to take our business to new heights.",
    image: two18
  },
  {
    year: "2019",
    title: "JANATHA AUTO WORKS AS MINING RAISING CONTRACTOR",
    description:
      "Janatha Auto Works was awarded 3-year work order in 2019 by NMDC, which was later renewed for another 3 years. We deployed 30 TATA Signa 2825 mining tippers for development work in NMDC Mines, and this project is still ongoing.",
    image: two16p2
  },
  {
    year: "2020 P1",
    title: "JANATHA AUTO WORKS AS MINING RAISING CONTRACTOR",
    description:
      "Janatha Auto Works received a 3-year work order from S M Minetech for operations in Bhadra Mines, where we deployed 20 Signa 2825 mining tippers.",
    image: two20
  },
  {
    year: "2020 P2",
    title: "JANATHA AUTOMOBILES ESTABLISHES NEW WORKSHOP AT DANAPUR",
    description:
      "We had our own land on NH50, Hospet-Bangalore Road, where we constructed a modern 25-bay workshop to accommodate the flow of heavy vehicles. This facility is constructed as per Tata Motors specifications. It also includes a dedicated body shop division with 6 bays, giving us complete service capabilities.",
    image: two20p2
  },
  // {
  //   year: "2022",
  //   title: "Best Performance by Turbo Energy Ltd.",
  //   description:
  //     "Awarded Best Performance by Turbo Energy Ltd. Purchased land in Bellary for a new workshop.",
  //   image:
  //     "https://res.cloudinary.com/dk10z0h1f/image/upload/v1742362110/bg-3_bw3pj2.jpg"
  // },
  {
    year: "2023 P1",
    title: "JANATHA AUTO WORKS AWARDED FOR BEST PERFORMANCE IN 2023",
    description:
      "OEM Turbo Energy Limited honored Janatha Auto Works with the Best Performance Award for outstanding sales and service of turbochargers in the financial year 2022–23. The award was presented during the Dealer Conference held in December 2023.",
    image:
      two23
  },
  {
    year: "2023 P2",
    title: "JAPL AWARDED APPRECIATION AWARD BY TATA MOTORS",
    description:
      "Janatha Automobiles Private Limited was awarded by TATA Motors for achieving the Best VME Realisation (Discount Sales Growth) in the South Zone durng Quarterly Signoff Meeting. Janatha Automobiles Private Limited was awarded by TATA Motors for creating highest fleet management solutions in May 2023.",
    image:
      two23p2
  },
  {
    year: "2023 P3",
    title: "JANATHA AUTOMOBILES EXPANDS SERVICE NETWORK",
    description:
      "Janatha Automobiles expands its service network by establishing a container workshop at Bellary in 2023.",
    image:
      two23p3
  },
  {
    year: "2023 P4",
    title: "JANATHA AUTOMOTIVES – TATA BATTERY DEALERSHIP ESTABLISHED",
    description:
      "In 2023, Janatha Automotives was started as a dealership company representing Tata Batteries for Raichur, Hospet, and Bellary region. This lateral integration within Janatha group was a natural extension of the business.",
    image:
      two23p4
  },
  {
    year: "2024 P1",
    title: "JANATHA AUTO WORKS BECOMES AUTHORIZED CCC FOR CUMMINS ENGINE PARTS",
    description:
      "In 2024, Janatha Auto Works received the authorization and was appointed as a CCC for the districts of Chitradurga, Hospet, Bellary, Koppal,Davangere, and Shimoga. This CCC distributorship began operations on March 1, 2024.",
    image: two24p1
  },
  {
    year: "2024 P2",
    title: "JANATHA AUTO WORKS OPENS NEW TEL TURBO SERVICING FACILITY AT BELLARY",
    description:
      "New facility started operations from November 2024.",
    image: two24p2
  },
  {
    year: "2024 P3",
    title: "JANATHA GROUP CELEBRATES ITS 50TH ANNIVERSARY",
    description:
      "Janatha group comomorates its 50th anniversary in a grand function held at its DANAPUR workshop facility showcasing its 50year journey.",
    image: two24p3
  }
];

const highlightMultiple = (text, highlights) => {
  const regex = new RegExp(`(${Object.keys(highlights).join("|")})`, "gi");
  return text.split(regex).map((part, i) => {
    const match = Object.keys(highlights).find(
      (key) => key.toLowerCase() === part.toLowerCase()
    );
    return match ? (
      <span key={i} className={highlights[match]}>
        {part}
      </span>
    ) : (
      part
    );
  });
};

const Milestone = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const scrollRef = useRef(null);
  const intervalRef = useRef(null);
  const yearButtonsRef = useRef([]);

  // Navigation functions
  const goToNext = () => {
    setSelectedIndex((prev) => (prev + 1) % timelineData.length);
  };

  const goToPrev = () => {
    setSelectedIndex((prev) => (prev - 1 + timelineData.length) % timelineData.length);
  };

  // Scroll to selected year
  useEffect(() => {
    if (yearButtonsRef.current[selectedIndex] && scrollRef.current) {
      const container = scrollRef.current;
      const button = yearButtonsRef.current[selectedIndex];
      
      const containerWidth = container.offsetWidth;
      const buttonLeft = button.offsetLeft;
      const buttonWidth = button.offsetWidth;
      
      const targetScroll = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
      
      container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  }, [selectedIndex]);

  // Auto-slide
  useEffect(() => {
    intervalRef.current = setInterval(goToNext, 5000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const handleYearSelect = (index) => {
    setSelectedIndex(index);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(goToNext, 5000);
  };

  const selectedData = timelineData[selectedIndex];

  return (
    <div className="w-full overflow-hidden relative my-12 pb-12" id="about">
      <div className="relative p-6 md:p-10 lg:p-14 rounded-2xl bg-gradient-to-br from-gray-900 to-blue-950 shadow-2xl border border-gray-100 overflow-hidden">
        {/* Decorative corner borders */}
        <div className="absolute top-4 left-4 w-12 h-12 border-t-4 border-l-4 border-white rounded-tl-lg"></div>
        <div className="absolute top-4 right-4 w-12 h-12 border-t-4 border-r-4 border-white rounded-tr-lg"></div>
        <div className="absolute bottom-4 left-4 w-12 h-12 border-b-4 border-l-4 border-white rounded-bl-lg"></div>
        <div className="absolute bottom-4 right-4 w-12 h-12 border-b-4 border-r-4 border-white rounded-br-lg"></div>
        
        {/* Background gradient elements */}
        <div className="absolute -top-20 -right-20 w-64 h-64 bg-blue-100 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-indigo-100 rounded-full opacity-20 blur-3xl"></div>
        
        <h2 className="text-3xl md:text-4xl lg:text-5xl text-center bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200 bg-gradient-to-r from-white to-blue-200 font-bold relative z-10">
          Milestone
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-4 rounded-full"></div>
        </h2>

        {/* Milestone Content */}
        <div className="flex flex-col lg:flex-row items-center justify-center my-8 gap-8 relative z-10">
          {/* Navigation Arrows */}
          <button 
            onClick={goToPrev}
            className="absolute left-0 lg:-left-12 top-1/2 transform -translate-y-1/2 z-10 bg-transparent rounded-full p-3 shadow-lg hover:bg-gray-50 transition-all hover:scale-110"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Image Container */}
          <motion.div 
            key={selectedIndex}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="w-full lg:w-1/2 aspect-video overflow-hidden flex items-center justify-center order-1 lg:order-2 relative"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-indigo-500/10 rounded-xl"></div>
            <img
              src={selectedData.image}
              alt={selectedData.title}
              className="w-full h-full  rounded-xl shadow-lg transition-transform duration-500 hover:scale-105"
            />
          </motion.div>

          {/* Text Content */}
          <div className="w-full lg:w-1/2 p-4 text-center lg:text-left order-2 lg:order-1">
            <motion.div
              key={selectedIndex}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <div className="mb-4">
                <span className="inline-block text-white py-1 rounded-full text-4xl font-extrabold">
                  {selectedData.year}
                </span>
              </div>
              
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight">
                {highlightMultiple(selectedData.title, {
                  "Ashok Leyland": "text-blue-500",
                  "TATA Motors": "text-blue-500",
                  "Janatha": "text-blue-500",
                  "NMDC": "text-green-500"
                })}
              </h2>
              
              <p className="text-white text-base md:text-lg leading-relaxed text-justify">
                {selectedData.description}
              </p>
            </motion.div>
          </div>

          <button 
            onClick={goToNext}
            className="absolute right-0 lg:-right-12 top-1/2 transform -translate-y-1/2 z-10 bg-transparent rounded-full p-3 shadow-lg hover:bg-gray-50 transition-all hover:scale-110"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Year Navigation */}
        <div className="relative mt-10 z-10">
          <div
            ref={scrollRef}
            className="flex overflow-x-auto scrollbar-hide space-x-3 pb-4 px-4"
            style={{ scrollBehavior: 'smooth' }}
          >
            {timelineData.map((item, index) => (
              <motion.button
                key={item.year}
                ref={el => yearButtonsRef.current[index] = el}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`flex-shrink-0 px-5 py-1.5 rounded-full text-sm font-semibold transition-all shadow-md
                  ${
                    selectedIndex === index
                      ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-100"
                  }`}
                onClick={() => handleYearSelect(index)}
              >
                {item.year}
              </motion.button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Milestone;